module.exports = __webpack_public_path__ + "img/J.f742d3f9.png";